import React from 'react';
import _ from 'lodash';
import Accordion from 'components/base/Accordion';
import Table from 'components/base/Table';
import {
  createdColumn,
  isInactiveRepository
} from './repositories-modal.service';
import { Flex, Separator } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Checkbox from 'components/base/Checkbox';
import { getColor } from 'common/constants/_colors';
import Icon from 'components/base/Icon';
import { TableWrapper } from './repositories-modal.components';
import useOwnerRepositories from './useOwnerRepositories';

const OwnerRepositoriesTitle = ({
  organizationName,
  localSelected,
  selectAll,
  unselectAll,
  isDisabled = false,
  repoLength,
  indeterminate,
  selected,
  numOfSelectableRepos,
  showCreatedOnHeader,
  newRepositories
}) => {
  const toggleSelection = () => {
    if (isDisabled) return;
    if (selected || indeterminate) {
      unselectAll();
      return;
    }
    if (numOfSelectableRepos) {
      selectAll();
    }
  };
  return (
    <Flex
      items='center'
      pt='small'
      pb='small'
      justify='space-between'
      width='100%'
    >
      <Flex items='center'>
        <Checkbox
          data-cy='OwnerRepositories'
          checked={isDisabled ? false : selected}
          indeterminate={!selected && indeterminate}
          disableRipple={!numOfSelectableRepos}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            toggleSelection();
          }}
        />
        <Text size='medium'>{_.capitalize(organizationName)}</Text>
        <Separator margin='0 1rem' />
        <Text size='medium' color='shuttleGray'>
          {localSelected}/{repoLength} Repos selected
        </Text>
      </Flex>
      {showCreatedOnHeader && (
        <Flex items='center'>
          {createdColumn({
            isNew: true,
            created_at: newRepositories.created_at,
            fontColor: 'osloGray',
            iconColor: 'dodgerBlue',
            number: newRepositories.length
          })}
        </Flex>
      )}
    </Flex>
  );
};

const OwnerRepositories = props => {
  const {
    repositories,
    ownerName,
    selected,
    isOpen,
    numOfSelectableRepos,
    setIsOpen,
    showCreatedOnHeader,
    newRepositories
  } = props;

  const { columns, unselectAll, selectAll, data, localSelected } =
    useOwnerRepositories(props);

  return (
    <Accordion
      CollapseIcon={
        isOpen
          ? () => <Icon color='shark' name='KeyboardArrowDown' size='medium' />
          : () => <Icon color='shark' name='ChevronRight' size='medium' />
      }
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      titleComponent={
        <OwnerRepositoriesTitle
          organizationName={ownerName}
          localSelected={localSelected}
          selectAll={selectAll}
          unselectAll={unselectAll}
          isDisabled={_.every(repositories, repository =>
            isInactiveRepository(repository.updated_at)
          )}
          indeterminate={_.some(
            repositories.map(({ id }) => id),
            id => selected.has(id)
          )}
          selected={_.every(
            repositories.map(({ id }) => id),
            id => selected.has(id)
          )}
          repoLength={repositories.length}
          numOfSelectableRepos={numOfSelectableRepos}
          showCreatedOnHeader={showCreatedOnHeader}
          newRepositories={newRepositories}
        />
      }
      borderBottom={`1px solid ${getColor('catskillWhite')}`}
      stickTitle={true}
      stickyElements={
        isOpen ? (
          <TableWrapper>
            <Table allowEmptyData columns={columns} data={[]} />
          </TableWrapper>
        ) : (
          []
        )
      }
    >
      <TableWrapper>
        <Table withTableHead={false} columns={columns} data={data}></Table>
      </TableWrapper>
    </Accordion>
  );
};

export default OwnerRepositories;
